import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "lib-overlay-dialog",
  templateUrl: "./overlay-dialog.component.html",
  styleUrls: ["./overlay-dialog.component.scss"],
  standalone: false,
})
export class OverlayDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IDialogData) {}
}
